"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
const WORKING_HOURS_VALUE_REGEX = /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/;
function isCompanySetting(object) {
    return checkCompanySetting(object).fulfilled;
}
exports.isCompanySetting = isCompanySetting;
function checkCompanySetting(object, options = { ignoreSuperfluousObjectProperties: true }) {
    const result = __1.check(object, __1.hasString("companyId"), __1.hasArray("status", __1.isRecord(__1.hasString("id").nonEmpty(), __1.hasString("name").nonEmpty(), __1.hasString("description").optional())), __1.hasObject("workingHours", __1.hasString("start").matchRegex(WORKING_HOURS_VALUE_REGEX), __1.hasString("end").matchRegex(WORKING_HOURS_VALUE_REGEX)).optional(), __1.hasArray("workingDays", __1.isRecord(__1.hasBoolean("enabled"))).optional(), __1.hasArray("workTypes", __1.isRecord(__1.hasString("id"), __1.hasString("name"), __1.hasBoolean("deleted"), __1.hasString("icon").optional())).optional()).withOptions(options).explain();
    if (object.workingDays && object.workingDays.length !== 7) {
        result.fulfilled = false;
        result.reasons = result.reasons || [];
        result.reasons.push({
            path: "$.workingDays.length",
            explanation: "has to be exact 7 (Mo-Su)",
            value: object.resourceId,
        });
    }
    return result;
}
exports.checkCompanySetting = checkCompanySetting;
//# sourceMappingURL=CompanySetting.js.map